import { Col, Container, Row } from "react-bootstrap"
import FieldArrayHelper from "@app/components/FormikHelper/FieldArrayHelper"
import FieldHelper from "@app/components/FormikHelper"
import RadioSwitcher from "@app/components/RadioSwitcher"
import React from "react"

export default function ListItem ({ label, options, name }) {
	return (<Container key={5} className={"content"}>
		<Row className={"align-items-center"}>
			<Col xs={"auto"}>
				{label}
			</Col>
			<Col className={"d-flex justify-content-end"}>
				<FieldArrayHelper
					name={name}
					className={"radio-switcher-container"}
					components={
						options.map(({ id, label, value }) => (<FieldHelper
							component={RadioSwitcher}
							key={id}
							id={id}
							label={label}
							value={value}
						/>))}
				/>
			</Col>
		</Row>
	</Container>)
}